import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import {NumericInputChangeEvent} from 'util/Types';

import {ExtraHeadersTransform} from '../../RunSchemaSpecConstants';
import {ExtraHeadersFormErrors, updateTransformationProperties} from './TransformFormUtils';

interface ExtraHeadersFormProps {
  transform: ExtraHeadersTransform;
  onChange: (transform: ExtraHeadersTransform) => void;
  formErrors: ExtraHeadersFormErrors;
}

export default function ExtraHeadersForm(props: ExtraHeadersFormProps): JSX.Element {
  return (
    <Row>
      <Col md={6}>
        <FieldLabel label="Row number of column header" isRequired={true} />
        <NumericInput
          min={1}
          value={
            props.transform.transformationProperties?.headerRowIndex
              ? // Value entered is 1-indexed, value persisted is 0-indexed
                props.transform.transformationProperties.headerRowIndex + 1
              : null
          }
          onChange={(e: NumericInputChangeEvent) => {
            if (e.target.numericValue != null) {
              props.onChange(
                // Value entered is 1-indexed, value persisted is 0-indexed
                updateTransformationProperties(props.transform, 'headerRowIndex', e.target.numericValue - 1)
              );
            }
          }}
          required={props.formErrors.headerRowIndex}
          validateInteger={true}
        />
        {props.formErrors.headerRowIndex ? (
          <ErrorMessage error="Header row number must be a positive integer" />
        ) : null}
      </Col>
      <Col md={6}>
        <FieldLabel label="Last row containing column header" />
        <NumericInput
          required={false}
          min={1}
          value={
            props.transform.transformationProperties?.lastHeaderRowIndex
              ? // Value entered is 1-indexed, value persisted is 0-indexed
                props.transform.transformationProperties.lastHeaderRowIndex + 1
              : null
          }
          onChange={(e: NumericInputChangeEvent) => {
            if (e.target.numericValue != null) {
              props.onChange(
                updateTransformationProperties(
                  props.transform,
                  'lastHeaderRowIndex',
                  // Value entered is 1-indexed, value persisted is 0-indexed
                  e.target.numericValue - 1
                )
              );
            } else if (e.target.value === '') {
              const newTransformationProperties = {...props.transform.transformationProperties};
              delete newTransformationProperties.lastHeaderRowIndex;
              props.onChange({...props.transform, transformationProperties: newTransformationProperties});
            }
          }}
          validateInteger={true}
        />
        {props.formErrors.lastHeaderRowIndex ? (
          <ErrorMessage error="Last row number must greater than header row number" />
        ) : null}
      </Col>
    </Row>
  );
}
